module.exports = __webpack_public_path__ + "img/what-to-expect-hero.2c971d97.png";